<template>
  <div class="page-training-index">
    <product-list :main-block="mainBlock" />
  </div>
</template>

<script>
  import ProductList from '@/components/Product/BlockList';
  import { getTrainingIndex } from '@/services/training';
  import { getMainBlockExplore } from '@/services/main-block';

  export default {
    name: 'PageTraining',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      ProductList,
    },
    data() {
      return {
        loading: false,
        render: {
          pageTitle: '',
        },

        mainBlock: [],
        mainBlockStart: 0,
        mainBlockAllLoad: false,
      };
    },
    methods: {
      async getTrainingIndex() {
        this.loading = true;

        const data = await getTrainingIndex();

        this.render = data.render;

        this.loading = false;
      },
      async getTrainingMainBlock() {
        if (this.mainBlockAllLoad) return;

        const params = {
          tab: 'reading_index',
          start: this.mainBlockStart,
        };
        const data = await getMainBlockExplore(params);

        const { length: totalLength } = data;

        const { length } = data.list;
        if (length === 0) {
          this.mainBlockAllLoad = true;
        }

        this.mainBlock.splice(totalLength, length, ...data.list);
        this.mainBlockStart = data.start;

        this.getTrainingMainBlock();
      },
      fetchData() {
        this.getTrainingIndex();
        // 重置mainBLock 拉取数据
        this.mainBlockAllLoad = false;
        this.mainBlockStart = 0;
        this.mainBlock = [];
        this.getTrainingMainBlock();
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">

</style>
